export class CustomError extends Error {
  shouldReport = false
}
